import { SET_ALERT, SET_LANGUAGE, SET_PAGE_TITLE, SET_SIDEBAR } from "./constants";
import themeStore from "./stores";

const themeReducers = (state = themeStore, action) => {
    switch (action.type) {
        case SET_ALERT:
            return { ...state, alert: action.payload }
        case SET_SIDEBAR:
            return { ...state, sideBar: action.payload }
        case SET_PAGE_TITLE:
            return { ...state, pageTitle: action.payload }
        case SET_LANGUAGE:
            return { ...state, language: action.payload }
        default:
            return state
    }
}

export default themeReducers
